import { IObservableArray, action } from "mobx";

export function copy<T>(src: T, dest: T, ignore?: string[]) {
  Object.getOwnPropertyNames(src).map(function (prop: string): void {
    if (ignore && ignore.indexOf(prop) !== -1) {
      return;
    }
    if (prop === "$mobx" || prop === "__mobxInitializedProps") {
      return;
    }
    dest[prop] = src[prop];
  });
}
export function sort<T>(items: Array<T>, prop: string): Array<T> {
  return items.sort(function (a: T, b: T): number {
    if (a[prop] < b[prop]) {
      return -1;
    } else if (a[prop] > b[prop]) {
      return 1;
    } else {
      return 0;
    }
  });
}
export function sortDesccending<T>(items: Array<T>, prop: string): Array<T> {
  return items.sort(function (a: T, b: T): number {
    if (b[prop] < a[prop]) {
      return -1;
    } else if (b[prop] > a[prop]) {
      return 1;
    } else {
      return 0;
    }
  });
}

export function copyArray<T>(src: Array<T>, dest: Array<T>, copy: (s: T) => T): void {
  if (src && dest) {
    let tempA: Array<T> = new Array<T>();
    src.map((instance: T): void => {
      tempA.push(copy(instance));
    });
    (dest as IObservableArray<T>).replace(tempA);
  }
}

export function mapArray<T>(src: Array<T>, dest: Array<T>) {
  if (src && dest) {
    (dest as IObservableArray<T>).replace(src);
  }
}
export function newObjectId(): string {
  var timestamp: string = (new Date().getTime() / 1000 | 0).toString(16);
  return timestamp + "xxxxxxxxxxxxxxxx".replace(/[x]/g, ((): string => {
    return (Math.random() * 16 | 0).toString(16);
  })).toLowerCase();
}



// WEBPACK FOOTER //
// ./src/utils/data.ts